import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuillEditorComponent } from 'ngx-quill';

import {
  EmailTemplate,
  EmailTemplateType,
} from '../../email-template';

@Component({
  selector: 'app-email-template-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, QuillEditorComponent],
  templateUrl: './email-template-modal.component.html',
  styleUrls: ['./email-template-modal.component.css'],
})
export class EmailTemplateModalComponent implements OnInit {
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() template: Partial<EmailTemplate> | null = null;

  form: UntypedFormGroup;

  templateTypes: { label: string; value: EmailTemplateType }[] = [
    { label: 'Proposal', value: 'PROPOSAL' },
    { label: 'Invoice', value: 'INVOICE' },
    { label: 'Payment', value: 'PAYMENT' },
    { label: 'Review', value: 'REVIEW' },
    { label: 'Generic', value: 'GENERIC' },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      id: [''],
      type: ['PROPOSAL', Validators.required],
      name: ['', [Validators.required, Validators.maxLength(255)]],
      subject: ['', [Validators.required, Validators.maxLength(255)]],
      body: ['', [Validators.required]],
      isDefault: [false],
    });
  }

  ngOnInit(): void {
    if (!this.template) return;

    this.form.patchValue({
      id: this.template.id ?? '',
      type: this.template.type ?? 'PROPOSAL',
      name: this.template.name ?? '',
      subject: this.template.subject ?? '',
      body: this.template.body ?? '',
      isDefault: this.template.isDefault ?? false,
    });

    if (this.mode === 'edit') {
      const isDefault = this.form.controls.isDefault.value;

      if (isDefault) {
        this.form.controls.type.disable();
        this.form.controls.isDefault.disable();
      } else {
        this.form.controls.type.enable();
        this.form.controls.isDefault.enable();
      }
    }
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const rawValue = this.form.getRawValue();
    this.activeModal.close(rawValue);
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}